import jwtDecode from "jwt-decode";

export default {
    'api': {
        getDomain() {
            if (typeof(window.apiEndPoint)!=="undefined"){
                return window.apiEndPoint;
            }
        },
        getConfig(params) {

            let token = this.getTokenOriginal();
            if (!token){
                token = this.getToken()
            }

            if (typeof(params)==="undefined" && !params){
                return {
                    'headers': {
                        'Authorization': 'Bearer ' + token,
                        'pragma': 'no-cache'
                    }
                }
            } else {
                return {
                    'headers': {
                        'Authorization': 'Bearer ' + token,
                        'pragma': 'no-cache'
                    },
                    'params':params
                }
            }

        },
        getToken() {
            return localStorage.getItem('apitoken');
        },
        getTokenOriginal() {
            return localStorage.getItem('apitoken_original');
        },
        getRoleOriginal(){
            return this.getTokenOriginal() ? jwtDecode(this.getTokenOriginal()).Role : null
        },
        getRole() {
            return localStorage.getItem('apitoken') ? jwtDecode(localStorage.getItem('apitoken')).Role : null
        },
        getStationType() {
          return localStorage.getItem('apitoken') ? jwtDecode(localStorage.getItem('apitoken')).StationType : null
        },
        getStationId() {
          return localStorage.getItem('apitoken') ? jwtDecode(localStorage.getItem('apitoken')).StationId : null
        },
        getWheelChangerId() {
            if (localStorage.getItem('apitoken')){
                return localStorage.getItem('WheelChangerId') ? localStorage.getItem('WheelChangerId') : jwtDecode(localStorage.getItem('apitoken')).WheelChangerId;
            }
            return null;
        },
        setWheelChangerId(wheelChangerId){
            if (this.getToken()){
                localStorage.setItem('WheelChangerId',wheelChangerId);
                return true;
            }
            return null;
        },
        clearStorage(){

            localStorage.removeItem('apitoken');
            localStorage.removeItem('role');
            localStorage.removeItem('WheelChangerId')
            localStorage.removeItem('apitoken_original');
        }
    },
    STATION_TYPES:{
        NONE:0,
        PORT:1,
        STATION:2,
        RECYCLE:3
    }
}



// WEBPACK FOOTER //
// ./src/config.js